module.exports = __webpack_public_path__ + "img/earth-africa.83ed563d.svg";